export function initializeCantonMap(Highcharts) {
  Highcharts.maps['countries/ch/ch-all'] = {
    title: 'Switzerland',
    version: '1.1.2',
    type: 'FeatureCollection',
    copyright: 'Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth',
    copyrightShort: 'Natural Earth',
    copyrightUrl: 'http://www.naturalearthdata.com',
    crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:EPSG:32632' } },
    'hc-transform': {
      default: {
        crs: '+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs',
        scale: 0.0020157689989,
        jsonres: 15.5,
        jsonmarginX: -999,
        jsonmarginY: 9851.0,
        xoffset: 265059.01009,
        yoffset: 5294295.52816
      }
    },
    features: [
      {
        type: 'Feature',
        id: 'CH.FR',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.55,
          'hc-middle-y': 0.57,
          'hc-key': 'ch-fr',
          'hc-a2': 'FR',
          labelrank: '7',
          hasc: 'CH.FR',
          'alt-name': 'Freiburg|Friburg|Friburgo',
          'woe-id': '2347088',
          subregion: null,
          fips: 'SZ06',
          'postal-code': 'FR',
          name: 'Freiburg',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '6.85219',
          'woe-name': 'Fribourg',
          latitude: '46.8411',
          'woe-label': 'Canton of Fribourg, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [1294, 6247],
                [1276, 6213],
                [1239, 6188],
                [1171, 6221],
                [1125, 6191],
                [1089, 6189],
                [1106, 6223],
                [1150, 6242],
                [1161, 6265],
                [1236, 6349],
                [1292, 6299],
                [1294, 6247]
              ]
            ],
            [
              [
                [1040, 6179],
                [1023, 6165],
                [986, 6224],
                [1044, 6280],
                [1074, 6264],
                [1070, 6213],
                [1040, 6179]
              ]
            ],
            [
              [
                [2142, 6886],
                [2122, 6882],
                [2115, 6900],
                [2150, 6909],
                [2142, 6886]
              ]
            ],
            [
              [
                [1020, 6605],
                [1286, 6812],
                [1384, 6710],
                [1343, 6671],
                [1404, 6640],
                [1410, 6618],
                [1379, 6561],
                [1362, 6467],
                [1406, 6446],
                [1378, 6390],
                [1334, 6372],
                [1290, 6376],
                [1257, 6397],
                [1199, 6377],
                [1161, 6379],
                [1080, 6412],
                [1092, 6446],
                [1063, 6460],
                [1029, 6513],
                [1020, 6605]
              ]
            ],
            [
              [
                [1364, 6874],
                [1458, 6947],
                [1601, 6735],
                [1672, 6646],
                [1677, 6612],
                [1719, 6633],
                [1753, 6681],
                [1782, 6757],
                [1808, 6745],
                [1835, 6783],
                [1807, 6801],
                [1751, 6930],
                [1737, 7047],
                [1929, 7062],
                [2104, 7129],
                [2126, 7122],
                [2152, 7063],
                [2121, 7021],
                [2077, 6996],
                [2098, 6870],
                [2071, 6798],
                [2238, 6751],
                [2428, 6730],
                [2438, 6651],
                [2389, 6598],
                [2346, 6623],
                [2328, 6609],
                [2336, 6495],
                [2305, 6381],
                [2295, 6235],
                [2313, 6147],
                [2362, 6122],
                [2403, 6080],
                [2437, 6069],
                [2478, 6032],
                [2460, 5923],
                [2434, 5876],
                [2361, 5895],
                [2323, 5858],
                [2330, 5756],
                [2318, 5677],
                [2297, 5659],
                [2231, 5655],
                [2133, 5572],
                [2060, 5516],
                [1921, 5478],
                [1840, 5391],
                [1793, 5357],
                [1722, 5351],
                [1646, 5300],
                [1599, 5224],
                [1543, 5198],
                [1513, 5250],
                [1485, 5359],
                [1355, 5462],
                [1297, 5477],
                [1222, 5417],
                [1159, 5423],
                [1117, 5510],
                [1139, 5551],
                [1201, 5548],
                [1230, 5528],
                [1325, 5637],
                [1293, 5634],
                [1219, 5688],
                [1156, 5679],
                [1138, 5694],
                [1092, 5683],
                [1101, 5760],
                [1094, 5836],
                [1104, 5929],
                [1172, 5956],
                [1236, 5962],
                [1267, 6019],
                [1425, 6231],
                [1434, 6260],
                [1385, 6281],
                [1382, 6301],
                [1433, 6326],
                [1500, 6417],
                [1497, 6466],
                [1520, 6514],
                [1570, 6561],
                [1580, 6586],
                [1548, 6606],
                [1556, 6683],
                [1539, 6719],
                [1493, 6693],
                [1435, 6768],
                [1364, 6874]
              ]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.NE',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.59,
          'hc-middle-y': 0.47,
          'hc-key': 'ch-ne',
          'hc-a2': 'NE',
          labelrank: '9',
          hasc: 'CH.NE',
          'alt-name': 'Neuenburg',
          'woe-id': '2347094',
          subregion: null,
          fips: 'SZ12',
          'postal-code': 'NE',
          name: 'Neuenburg',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '6.76076',
          'woe-name': 'Neuchâtel',
          latitude: '46.9893',
          'woe-label': 'Canton of Neuchatel, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [251, 6650],
              [266, 6719],
              [260, 6758],
              [221, 6851],
              [261, 6971],
              [378, 7034],
              [636, 7107],
              [798, 7223],
              [855, 7299],
              [828, 7365],
              [885, 7440],
              [945, 7460],
              [998, 7504],
              [997, 7564],
              [1069, 7586],
              [1222, 7721],
              [1250, 7709],
              [1298, 7682],
              [1324, 7645],
              [1345, 7581],
              [1331, 7515],
              [1307, 7468],
              [1314, 7446],
              [1695, 7553],
              [1695, 7505],
              [1795, 7455],
              [1822, 7418],
              [1808, 7407],
              [1808, 7311],
              [1707, 7259],
              [1640, 7090],
              [1458, 6947],
              [1364, 6874],
              [1286, 6812],
              [1020, 6605],
              [983, 6693],
              [976, 6783],
              [938, 6835],
              [933, 6933],
              [790, 6852],
              [688, 6778],
              [615, 6756],
              [418, 6658],
              [251, 6650]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.AG',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.64,
          'hc-middle-y': 0.41,
          'hc-key': 'ch-ag',
          'hc-a2': 'AG',
          labelrank: '9',
          hasc: 'CH.AG',
          'alt-name': 'Argovia|Arg¢via|Argovie',
          'woe-id': '2347083',
          subregion: null,
          fips: 'SZ01',
          'postal-code': 'AG',
          name: 'Aargau',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '8.199949999999999',
          'woe-name': 'Aargau',
          latitude: '47.4176',
          'woe-label': 'Canton of Aargau, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [3350, 9002],
              [3443, 9020],
              [3487, 9044],
              [3569, 9154],
              [3602, 9137],
              [3753, 9126],
              [3767, 9111],
              [3785, 9030],
              [4091, 9026],
              [4197, 9049],
              [4279, 9134],
              [4374, 9173],
              [4414, 9215],
              [4541, 9235],
              [4583, 9234],
              [4671, 9212],
              [4712, 9130],
              [4735, 9114],
              [4824, 9090],
              [4981, 9089],
              [4977, 9068],
              [4923, 8981],
              [4871, 8930],
              [4832, 8867],
              [4818, 8766],
              [4830, 8717],
              [4881, 8606],
              [4898, 8552],
              [4936, 8497],
              [4926, 8468],
              [4862, 8404],
              [4858, 8386],
              [4934, 8330],
              [4928, 8260],
              [4963, 8205],
              [5033, 8226],
              [5026, 8193],
              [4959, 8099],
              [4883, 8065],
              [4888, 8037],
              [4940, 7924],
              [4909, 7865],
              [4906, 7834],
              [4917, 7688],
              [4933, 7566],
              [4865, 7569],
              [4805, 7617],
              [4771, 7675],
              [4660, 8005],
              [4633, 8038],
              [4595, 8055],
              [4555, 8051],
              [4515, 8005],
              [4449, 7882],
              [4389, 7852],
              [4349, 7881],
              [4335, 7929],
              [4271, 7932],
              [4224, 7948],
              [4189, 7986],
              [4025, 7924],
              [3974, 8029],
              [3938, 8045],
              [3877, 8043],
              [3874, 7972],
              [3856, 7939],
              [3795, 7918],
              [3742, 7919],
              [3597, 7892],
              [3567, 7945],
              [3560, 8021],
              [3643, 8165],
              [3750, 8259],
              [3787, 8246],
              [3937, 8222],
              [3974, 8243],
              [4052, 8397],
              [4050, 8463],
              [3998, 8485],
              [3967, 8521],
              [3941, 8579],
              [3937, 8640],
              [3917, 8665],
              [3880, 8672],
              [3851, 8692],
              [3847, 8762],
              [3775, 8771],
              [3636, 8980],
              [3582, 8983],
              [3570, 8926],
              [3510, 8873],
              [3478, 8869],
              [3467, 8938],
              [3350, 9002]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.LU',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.43,
          'hc-middle-y': 0.39,
          'hc-key': 'ch-lu',
          'hc-a2': 'LU',
          labelrank: '9',
          hasc: 'CH.LU',
          'alt-name': 'Lucerna|Luzern',
          'woe-id': '2347093',
          subregion: null,
          fips: 'SZ11',
          'postal-code': 'LU',
          name: 'Luzern',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '8.172190000000001',
          'woe-name': 'Lucerne',
          latitude: '47.096',
          'woe-label': 'Canton of Lucerne, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [3597, 7892],
              [3742, 7919],
              [3795, 7918],
              [3856, 7939],
              [3874, 7972],
              [3877, 8043],
              [3938, 8045],
              [3974, 8029],
              [4025, 7924],
              [4189, 7986],
              [4224, 7948],
              [4271, 7932],
              [4335, 7929],
              [4349, 7881],
              [4389, 7852],
              [4449, 7882],
              [4515, 8005],
              [4555, 8051],
              [4595, 8055],
              [4633, 8038],
              [4660, 8005],
              [4771, 7675],
              [4805, 7617],
              [4865, 7569],
              [4933, 7566],
              [4962, 7518],
              [5006, 7502],
              [5020, 7464],
              [4947, 7421],
              [4923, 7365],
              [4889, 7318],
              [4889, 7288],
              [4928, 7256],
              [4965, 7272],
              [5059, 7247],
              [5150, 7162],
              [5166, 7133],
              [5150, 7088],
              [5071, 7047],
              [5026, 7103],
              [4992, 7110],
              [4969, 7074],
              [4867, 7069],
              [4836, 7099],
              [4748, 7064],
              [4691, 7071],
              [4603, 7067],
              [4503, 7034],
              [4505, 6977],
              [4373, 6965],
              [4327, 6931],
              [4334, 6865],
              [4286, 6821],
              [4228, 6749],
              [4184, 6763],
              [4144, 6726],
              [4118, 6634],
              [4070, 6522],
              [4101, 6406],
              [4061, 6345],
              [4013, 6349],
              [3935, 6313],
              [3902, 6314],
              [3843, 6397],
              [3688, 6525],
              [3651, 6566],
              [3630, 6662],
              [3656, 6700],
              [3667, 6745],
              [3667, 6823],
              [3721, 6849],
              [3763, 6855],
              [3797, 6904],
              [3837, 7012],
              [3853, 7092],
              [3786, 7118],
              [3723, 7124],
              [3716, 7181],
              [3668, 7253],
              [3663, 7298],
              [3672, 7437],
              [3704, 7531],
              [3678, 7699],
              [3597, 7892]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.7',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.51,
          'hc-middle-y': 0.34,
          'hc-key': 'ch-7',
          'hc-a2': 'NW',
          labelrank: '9',
          hasc: 'CH.NW',
          'alt-name': 'Nidvaldo|Nidwald|Unterwalden-le-Bas|Nidwaldo',
          'woe-id': '2347095',
          subregion: null,
          fips: 'SZ13',
          'postal-code': null,
          name: 'Nidwalden',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '8.40344',
          'woe-name': 'Nidwalden',
          latitude: '46.934',
          'woe-label': 'Canton of Nidwalden, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [4505, 6977],
              [4503, 7034],
              [4603, 7067],
              [4691, 7071],
              [4748, 7064],
              [4836, 7099],
              [4867, 7069],
              [4969, 7074],
              [4992, 7110],
              [5026, 7103],
              [5071, 7047],
              [5129, 7006],
              [5300, 7028],
              [5300, 6989],
              [5267, 6886],
              [5222, 6835],
              [5100, 6774],
              [5054, 6728],
              [5081, 6664],
              [5085, 6569],
              [4970, 6566],
              [4936, 6607],
              [4915, 6611],
              [4856, 6580],
              [4846, 6632],
              [4818, 6611],
              [4848, 6482],
              [4847, 6449],
              [4916, 6353],
              [4953, 6338],
              [4959, 6312],
              [4890, 6291],
              [4835, 6341],
              [4786, 6371],
              [4737, 6439],
              [4732, 6521],
              [4739, 6625],
              [4755, 6680],
              [4756, 6773],
              [4739, 6798],
              [4683, 6825],
              [4657, 6854],
              [4696, 6960],
              [4682, 6974],
              [4592, 7003],
              [4505, 6977]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.VS',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.47,
          'hc-middle-y': 0.61,
          'hc-key': 'ch-vs',
          'hc-a2': 'VS',
          labelrank: '9',
          hasc: 'CH.VS',
          'alt-name': 'Vallais|Vallese|Wallis',
          'woe-id': '2347104',
          subregion: null,
          fips: 'SZ22',
          'postal-code': 'VS',
          name: 'Wallis',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '7.61347',
          'woe-name': 'Valais',
          latitude: '46.2023',
          'woe-label': 'Canton of Valais, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [1217, 5061],
              [1218, 5061],
              [1282, 4963],
              [1280, 4870],
              [1366, 4820],
              [1386, 4727],
              [1532, 4456],
              [1628, 4312],
              [1802, 4411],
              [1860, 4481],
              [1888, 4492],
              [1970, 4584],
              [2009, 4659],
              [2007, 4716],
              [2080, 4793],
              [2165, 4840],
              [2198, 4903],
              [2276, 4928],
              [2297, 4920],
              [2297, 4859],
              [2326, 4847],
              [2417, 4875],
              [2507, 4947],
              [2647, 4953],
              [2724, 4927],
              [2847, 4967],
              [2882, 4998],
              [2838, 5035],
              [2893, 5068],
              [2975, 5091],
              [3040, 5162],
              [3090, 5155],
              [3248, 5076],
              [3276, 5078],
              [3571, 5285],
              [3657, 5280],
              [3708, 5298],
              [3864, 5401],
              [3880, 5428],
              [3862, 5480],
              [3954, 5545],
              [4016, 5547],
              [4220, 5506],
              [4297, 5462],
              [4361, 5454],
              [4367, 5426],
              [4401, 5416],
              [4526, 5441],
              [4584, 5461],
              [4695, 5521],
              [4758, 5567],
              [4806, 5629],
              [4833, 5759],
              [4858, 5815],
              [4904, 5872],
              [4930, 5876],
              [4959, 5842],
              [4952, 5769],
              [4924, 5659],
              [4958, 5554],
              [4994, 5497],
              [5088, 5445],
              [5017, 5351],
              [4977, 5325],
              [4893, 5304],
              [4894, 5275],
              [4865, 5204],
              [4868, 5163],
              [4766, 5142],
              [4700, 5107],
              [4649, 5053],
              [4628, 5009],
              [4653, 4982],
              [4639, 4915],
              [4587, 4866],
              [4519, 4832],
              [4399, 4678],
              [4349, 4643],
              [4244, 4621],
              [4192, 4598],
              [4144, 4551],
              [4109, 4488],
              [4173, 4425],
              [4243, 4286],
              [4248, 4159],
              [4195, 4047],
              [4088, 3957],
              [4012, 3944],
              [3970, 3890],
              [3949, 3712],
              [3888, 3608],
              [3847, 3587],
              [3675, 3550],
              [3640, 3523],
              [3613, 3473],
              [3605, 3407],
              [3555, 3405],
              [3540, 3334],
              [3510, 3318],
              [3452, 3333],
              [3386, 3333],
              [3270, 3377],
              [3207, 3362],
              [3178, 3373],
              [3130, 3449],
              [3057, 3505],
              [2811, 3572],
              [2770, 3551],
              [2719, 3478],
              [2668, 3473],
              [2595, 3443],
              [2450, 3341],
              [2372, 3315],
              [2190, 3338],
              [2089, 3287],
              [1938, 3229],
              [1865, 3218],
              [1785, 3218],
              [1711, 3235],
              [1656, 3270],
              [1550, 3394],
              [1461, 3640],
              [1302, 3829],
              [1248, 3855],
              [1191, 3816],
              [1147, 3837],
              [1151, 3963],
              [1194, 4027],
              [1197, 4053],
              [1161, 4090],
              [970, 4138],
              [951, 4196],
              [976, 4315],
              [1022, 4438],
              [1112, 4602],
              [1060, 4697],
              [977, 4790],
              [933, 4871],
              [947, 4910],
              [1013, 4983],
              [1030, 5075],
              [1189, 5045],
              [1217, 5061]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.SG',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.6,
          'hc-middle-y': 0.61,
          'hc-key': 'ch-sg',
          'hc-a2': 'SG',
          labelrank: '9',
          hasc: 'CH.SG',
          'alt-name': 'Saint-Gall|San Gallo|Son Gagl',
          'woe-id': '2347097',
          subregion: null,
          fips: 'SZ15',
          'postal-code': 'SG',
          name: 'Sankt Gallen',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '9.212669999999999',
          'woe-name': 'Sankt Gallen',
          latitude: '47.1524',
          'woe-label': 'Canton of St. Gallen, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [7460, 8805],
              [7506, 8765],
              [7560, 8781],
              [7642, 8849],
              [7718, 8740],
              [7805, 8701],
              [7873, 8642],
              [7873, 8495],
              [7850, 8442],
              [7760, 8326],
              [7728, 8210],
              [7649, 8112],
              [7535, 7916],
              [7495, 7799],
              [7490, 7682],
              [7554, 7519],
              [7556, 7445],
              [7534, 7399],
              [7470, 7324],
              [7473, 7291],
              [7492, 7220],
              [7519, 7162],
              [7606, 7013],
              [7563, 6987],
              [7547, 6940],
              [7513, 6907],
              [7485, 6851],
              [7477, 6775],
              [7439, 6701],
              [7378, 6660],
              [7303, 6705],
              [6984, 6750],
              [6952, 6746],
              [6915, 6790],
              [6919, 6823],
              [6889, 6921],
              [6906, 7040],
              [6892, 7096],
              [6861, 7160],
              [6822, 7201],
              [6716, 7175],
              [6657, 7205],
              [6661, 7220],
              [6743, 7277],
              [6757, 7326],
              [6768, 7491],
              [6519, 7539],
              [6483, 7560],
              [6358, 7673],
              [6306, 7653],
              [6243, 7716],
              [6228, 7746],
              [6236, 7809],
              [6162, 7832],
              [5939, 7810],
              [5810, 7833],
              [5843, 7913],
              [5887, 7947],
              [6015, 7936],
              [6154, 8001],
              [6187, 8037],
              [6185, 8066],
              [6269, 8168],
              [6248, 8269],
              [6182, 8385],
              [6206, 8387],
              [6281, 8499],
              [6316, 8571],
              [6413, 8596],
              [6415, 8664],
              [6350, 8710],
              [6350, 8755],
              [6415, 8790],
              [6496, 8787],
              [6513, 8766],
              [6579, 8760],
              [6647, 8766],
              [6698, 8829],
              [6733, 8787],
              [6810, 8751],
              [6944, 8725],
              [6974, 8744],
              [7036, 8755],
              [7059, 8806],
              [7047, 8858],
              [6977, 8856],
              [6968, 8871],
              [7008, 8894],
              [7130, 8927],
              [7152, 8892],
              [7149, 8830],
              [7201, 8762],
              [7237, 8740],
              [7253, 8772],
              [7373, 8863],
              [7397, 8848],
              [7386, 8815],
              [7415, 8794],
              [7460, 8805]
            ],
            [
              [7494, 8297],
              [7477, 8349],
              [7489, 8436],
              [7583, 8467],
              [7616, 8450],
              [7716, 8513],
              [7712, 8545],
              [7721, 8579],
              [7775, 8633],
              [7679, 8649],
              [7581, 8697],
              [7510, 8644],
              [7392, 8590],
              [7344, 8576],
              [7321, 8515],
              [7278, 8490],
              [7226, 8490],
              [7035, 8454],
              [6980, 8466],
              [6874, 8457],
              [6813, 8343],
              [6781, 8309],
              [6812, 8248],
              [6856, 8236],
              [6823, 8189],
              [6817, 8153],
              [6834, 8075],
              [6806, 8043],
              [6855, 8010],
              [6973, 7995],
              [7071, 7936],
              [7125, 7947],
              [7194, 7905],
              [7230, 7901],
              [7296, 7926],
              [7376, 7975],
              [7409, 8012],
              [7455, 8099],
              [7494, 8297]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.AR',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.18,
          'hc-middle-y': 0.53,
          'hc-key': 'ch-ar',
          'hc-a2': 'AR',
          labelrank: '9',
          hasc: 'CH.AR',
          'alt-name':
            'Appenzell Ausser-Rhoden|Appenzell Outer Rhodes|Appenzell dadens|Appenzell Rhodes Extérieures|Appenzello Esterno',
          'woe-id': '2347084',
          subregion: null,
          fips: 'SZ02',
          'postal-code': 'AR',
          name: 'Appenzell Ausserrhoden',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '9.397259999999999',
          'woe-name': 'Appenzell Ausserrhoden',
          latitude: '47.3911',
          'woe-label': 'Canton of Appenzell Outer-Rhodes, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [7489, 8436],
              [7477, 8349],
              [7494, 8297],
              [7418, 8299],
              [7166, 8415],
              [7152, 8401],
              [7150, 8332],
              [7125, 8275],
              [7071, 8223],
              [7057, 8121],
              [7070, 8070],
              [7100, 8025],
              [7125, 7947],
              [7071, 7936],
              [6973, 7995],
              [6855, 8010],
              [6806, 8043],
              [6834, 8075],
              [6817, 8153],
              [6823, 8189],
              [6856, 8236],
              [6812, 8248],
              [6781, 8309],
              [6813, 8343],
              [6874, 8457],
              [6980, 8466],
              [7035, 8454],
              [7226, 8490],
              [7278, 8490],
              [7321, 8515],
              [7344, 8576],
              [7392, 8590],
              [7510, 8644],
              [7581, 8697],
              [7679, 8649],
              [7775, 8633],
              [7714, 8608],
              [7633, 8603],
              [7637, 8581],
              [7712, 8545],
              [7716, 8513],
              [7616, 8450],
              [7621, 8539],
              [7585, 8576],
              [7546, 8549],
              [7548, 8503],
              [7496, 8476],
              [7489, 8436]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.TI',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.51,
          'hc-middle-y': 0.37,
          'hc-key': 'ch-ti',
          'hc-a2': 'TI',
          labelrank: '9',
          hasc: 'CH.TI',
          'alt-name': 'Tesino|Tessin',
          'woe-id': '2347102',
          subregion: null,
          fips: 'SZ20',
          'postal-code': 'TI',
          name: 'Tessin',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '8.790190000000001',
          'woe-name': 'Ticino',
          latitude: '46.3604',
          'woe-label': 'Canton of Ticino, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [6737, 4195],
              [6560, 4074],
              [6516, 4007],
              [6506, 3962],
              [6511, 3884],
              [6485, 3809],
              [6409, 3779],
              [6347, 3731],
              [6336, 3691],
              [6379, 3570],
              [6300, 3497],
              [6300, 3462],
              [6326, 3436],
              [6368, 3340],
              [6467, 3301],
              [6495, 3244],
              [6485, 3185],
              [6425, 3067],
              [6347, 2972],
              [6274, 2986],
              [6195, 3021],
              [6099, 2992],
              [6132, 3130],
              [6128, 3190],
              [6095, 3281],
              [6029, 3411],
              [5997, 3446],
              [5858, 3520],
              [5780, 3536],
              [5836, 3660],
              [5905, 3744],
              [5941, 3825],
              [5880, 3906],
              [5844, 3919],
              [5731, 3923],
              [5695, 3968],
              [5660, 3969],
              [5605, 3926],
              [5563, 3928],
              [5450, 3995],
              [5380, 4023],
              [5229, 4249],
              [5161, 4320],
              [5032, 4379],
              [4988, 4416],
              [4962, 4472],
              [4953, 4557],
              [4962, 4646],
              [5002, 4826],
              [5011, 4926],
              [5011, 5031],
              [5001, 5109],
              [4969, 5157],
              [4900, 5170],
              [4868, 5163],
              [4865, 5204],
              [4894, 5275],
              [4893, 5304],
              [4977, 5325],
              [5017, 5351],
              [5088, 5445],
              [5168, 5510],
              [5202, 5606],
              [5261, 5628],
              [5471, 5579],
              [5571, 5622],
              [5650, 5585],
              [5835, 5567],
              [5976, 5592],
              [6098, 5640],
              [6126, 5669],
              [6117, 5706],
              [6138, 5748],
              [6236, 5784],
              [6257, 5729],
              [6339, 5721],
              [6394, 5694],
              [6434, 5645],
              [6403, 5578],
              [6378, 5446],
              [6406, 5345],
              [6458, 5264],
              [6527, 5269],
              [6555, 5217],
              [6549, 5130],
              [6576, 5039],
              [6553, 4962],
              [6556, 4857],
              [6510, 4764],
              [6512, 4696],
              [6479, 4632],
              [6481, 4601],
              [6526, 4503],
              [6521, 4428],
              [6553, 4360],
              [6608, 4318],
              [6680, 4236],
              [6737, 4195]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.GL',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.51,
          'hc-middle-y': 0.44,
          'hc-key': 'ch-gl',
          'hc-a2': 'GL',
          labelrank: '9',
          hasc: 'CH.GL',
          'alt-name': 'Glaris|Glarona|Glaruna',
          'woe-id': '2347090',
          subregion: null,
          fips: 'SZ08',
          'postal-code': 'GL',
          name: 'Glarus',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '9.056509999999999',
          'woe-name': 'Glarus',
          latitude: '47.0096',
          'woe-label': 'Canton of Glarus, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [6306, 7653],
              [6358, 7673],
              [6483, 7560],
              [6519, 7539],
              [6768, 7491],
              [6757, 7326],
              [6743, 7277],
              [6661, 7220],
              [6657, 7205],
              [6716, 7175],
              [6822, 7201],
              [6861, 7160],
              [6892, 7096],
              [6906, 7040],
              [6889, 6921],
              [6919, 6823],
              [6915, 6790],
              [6849, 6731],
              [6808, 6675],
              [6776, 6658],
              [6697, 6650],
              [6616, 6594],
              [6572, 6594],
              [6544, 6622],
              [6482, 6634],
              [6437, 6613],
              [6435, 6573],
              [6400, 6495],
              [6349, 6440],
              [6295, 6414],
              [6163, 6374],
              [6132, 6380],
              [6122, 6412],
              [6036, 6426],
              [6036, 6531],
              [6116, 6595],
              [6192, 6619],
              [6218, 6651],
              [6218, 6706],
              [6176, 6796],
              [6227, 6822],
              [6247, 6910],
              [6234, 6947],
              [6174, 7004],
              [6180, 7032],
              [6113, 7128],
              [6080, 7158],
              [6092, 7197],
              [6177, 7245],
              [6240, 7345],
              [6237, 7415],
              [6306, 7653]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.GR',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.49,
          'hc-middle-y': 0.42,
          'hc-key': 'ch-gr',
          'hc-a2': 'GR',
          labelrank: '9',
          hasc: 'CH.GR',
          'alt-name': 'Graubünden|Grigioni|Grischun|Grisons',
          'woe-id': '2347091',
          subregion: null,
          fips: 'SZ09',
          'postal-code': 'GR',
          name: 'Graubünden',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '9.559530000000001',
          'woe-name': 'Graubünden',
          latitude: '46.6729',
          'woe-label': 'Canton of Graubunden, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [6737, 4195],
              [6680, 4236],
              [6608, 4318],
              [6553, 4360],
              [6521, 4428],
              [6526, 4503],
              [6481, 4601],
              [6479, 4632],
              [6512, 4696],
              [6510, 4764],
              [6556, 4857],
              [6553, 4962],
              [6576, 5039],
              [6549, 5130],
              [6555, 5217],
              [6527, 5269],
              [6458, 5264],
              [6406, 5345],
              [6378, 5446],
              [6403, 5578],
              [6434, 5645],
              [6394, 5694],
              [6339, 5721],
              [6257, 5729],
              [6236, 5784],
              [6138, 5748],
              [6117, 5706],
              [6126, 5669],
              [6098, 5640],
              [5976, 5592],
              [5835, 5567],
              [5650, 5585],
              [5571, 5622],
              [5578, 5669],
              [5554, 5751],
              [5526, 5769],
              [5513, 5833],
              [5548, 5927],
              [5551, 5979],
              [5576, 6008],
              [5662, 6043],
              [5742, 6140],
              [5784, 6155],
              [5829, 6141],
              [5881, 6166],
              [5879, 6198],
              [5924, 6270],
              [5926, 6340],
              [6010, 6392],
              [6036, 6426],
              [6122, 6412],
              [6132, 6380],
              [6163, 6374],
              [6295, 6414],
              [6349, 6440],
              [6400, 6495],
              [6435, 6573],
              [6437, 6613],
              [6482, 6634],
              [6544, 6622],
              [6572, 6594],
              [6616, 6594],
              [6697, 6650],
              [6776, 6658],
              [6808, 6675],
              [6849, 6731],
              [6915, 6790],
              [6952, 6746],
              [6984, 6750],
              [7303, 6705],
              [7378, 6660],
              [7439, 6701],
              [7477, 6775],
              [7485, 6851],
              [7513, 6907],
              [7547, 6940],
              [7563, 6987],
              [7606, 7013],
              [7519, 7162],
              [7492, 7220],
              [7473, 7291],
              [7527, 7276],
              [7672, 7253],
              [7721, 7269],
              [7765, 7257],
              [7889, 7274],
              [7929, 7268],
              [8379, 7131],
              [8376, 7091],
              [8400, 7084],
              [8392, 6868],
              [8423, 6826],
              [8483, 6781],
              [8738, 6702],
              [8831, 6616],
              [8885, 6586],
              [8989, 6554],
              [9038, 6553],
              [9099, 6571],
              [9202, 6626],
              [9226, 6661],
              [9244, 6762],
              [9280, 6823],
              [9424, 6823],
              [9424, 6888],
              [9464, 6968],
              [9523, 7038],
              [9591, 7079],
              [9617, 7079],
              [9655, 7045],
              [9706, 6966],
              [9810, 6878],
              [9824, 6820],
              [9797, 6701],
              [9804, 6627],
              [9793, 6515],
              [9771, 6462],
              [9721, 6398],
              [9751, 6249],
              [9723, 6204],
              [9683, 6178],
              [9672, 6057],
              [9624, 5990],
              [9614, 5957],
              [9635, 5891],
              [9679, 5842],
              [9781, 5833],
              [9832, 5791],
              [9851, 5725],
              [9851, 5635],
              [9833, 5549],
              [9801, 5493],
              [9758, 5484],
              [9586, 5526],
              [9502, 5516],
              [9444, 5533],
              [9397, 5582],
              [9298, 5615],
              [9286, 5652],
              [9293, 5763],
              [9255, 5794],
              [9193, 5792],
              [8967, 5724],
              [8945, 5711],
              [8907, 5571],
              [8816, 5461],
              [8814, 5360],
              [8804, 5323],
              [8813, 5265],
              [8846, 5232],
              [8805, 5160],
              [8843, 5113],
              [8914, 5087],
              [9021, 5067],
              [9063, 5051],
              [9081, 5013],
              [9064, 4937],
              [8997, 4867],
              [8980, 4833],
              [8967, 4754],
              [9000, 4687],
              [9100, 4587],
              [9132, 4526],
              [9102, 4459],
              [9035, 4416],
              [8934, 4376],
              [8854, 4376],
              [8851, 4455],
              [8826, 4513],
              [8730, 4596],
              [8694, 4644],
              [8677, 4720],
              [8675, 4788],
              [8659, 4845],
              [8598, 4883],
              [8502, 4899],
              [8397, 4879],
              [8238, 4796],
              [8188, 4779],
              [8099, 4820],
              [8047, 4791],
              [8046, 4684],
              [8010, 4633],
              [7964, 4614],
              [7689, 4615],
              [7632, 4635],
              [7581, 4670],
              [7550, 4712],
              [7502, 4837],
              [7427, 4883],
              [7405, 4920],
              [7408, 4973],
              [7391, 5305],
              [7384, 5327],
              [7326, 5294],
              [7290, 5226],
              [7246, 5224],
              [7185, 5282],
              [7183, 5325],
              [7135, 5337],
              [7018, 5322],
              [6973, 5280],
              [6931, 5196],
              [6913, 5111],
              [6936, 5064],
              [6968, 5042],
              [6967, 4914],
              [7000, 4791],
              [7003, 4746],
              [6989, 4669],
              [6919, 4522],
              [6883, 4398],
              [6834, 4336],
              [6779, 4303],
              [6737, 4195]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.SZ',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.68,
          'hc-middle-y': 0.44,
          'hc-key': 'ch-sz',
          'hc-a2': 'SZ',
          labelrank: '9',
          hasc: 'CH.SZ',
          'alt-name': null,
          'woe-id': '2347099',
          subregion: null,
          fips: 'SZ17',
          'postal-code': 'SZ',
          name: 'Schwyz',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '8.68573',
          'woe-name': 'Schwyz',
          latitude: '47.0455',
          'woe-label': 'Canton of Schwyz, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [6306, 7653],
              [6237, 7415],
              [6240, 7345],
              [6177, 7245],
              [6092, 7197],
              [6080, 7158],
              [6113, 7128],
              [6180, 7032],
              [6174, 7004],
              [6234, 6947],
              [6247, 6910],
              [6227, 6822],
              [6176, 6796],
              [6068, 6735],
              [5963, 6692],
              [5955, 6751],
              [5914, 6790],
              [5915, 6821],
              [5891, 6841],
              [5802, 6844],
              [5774, 6863],
              [5648, 6800],
              [5586, 6884],
              [5515, 6883],
              [5413, 6928],
              [5391, 7020],
              [5370, 7031],
              [5300, 7028],
              [5129, 7006],
              [5071, 7047],
              [5150, 7088],
              [5166, 7133],
              [5150, 7162],
              [5059, 7247],
              [4965, 7272],
              [4928, 7256],
              [4889, 7288],
              [4889, 7318],
              [4923, 7365],
              [4947, 7421],
              [5020, 7464],
              [5069, 7494],
              [5110, 7485],
              [5151, 7392],
              [5273, 7401],
              [5315, 7372],
              [5364, 7378],
              [5482, 7416],
              [5508, 7436],
              [5575, 7515],
              [5593, 7567],
              [5636, 7611],
              [5592, 7642],
              [5578, 7716],
              [5615, 7754],
              [5708, 7812],
              [5810, 7833],
              [5939, 7810],
              [6162, 7832],
              [6236, 7809],
              [6228, 7746],
              [6243, 7716],
              [6306, 7653]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.TG',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.48,
          'hc-middle-y': 0.33,
          'hc-key': 'ch-tg',
          'hc-a2': 'TG',
          labelrank: '9',
          hasc: 'CH.TG',
          'alt-name': 'Thurgovie|Turgovia|Turg¢via',
          'woe-id': '2347101',
          subregion: null,
          fips: 'SZ19',
          'postal-code': 'TG',
          name: 'Thurgau',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '9.14593',
          'woe-name': 'Thurgau',
          latitude: '47.5858',
          'woe-label': 'Canton of Thurgau, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [7460, 8805],
              [7415, 8794],
              [7386, 8815],
              [7397, 8848],
              [7373, 8863],
              [7253, 8772],
              [7237, 8740],
              [7201, 8762],
              [7149, 8830],
              [7152, 8892],
              [7130, 8927],
              [7008, 8894],
              [6968, 8871],
              [6977, 8856],
              [7047, 8858],
              [7059, 8806],
              [7036, 8755],
              [6974, 8744],
              [6944, 8725],
              [6810, 8751],
              [6733, 8787],
              [6698, 8829],
              [6647, 8766],
              [6579, 8760],
              [6513, 8766],
              [6496, 8787],
              [6415, 8790],
              [6350, 8755],
              [6350, 8710],
              [6415, 8664],
              [6413, 8596],
              [6316, 8571],
              [6281, 8499],
              [6206, 8387],
              [6182, 8385],
              [6088, 8485],
              [6133, 8582],
              [6091, 8615],
              [6079, 8686],
              [6056, 8701],
              [6048, 8749],
              [6072, 8775],
              [6085, 8889],
              [6063, 8914],
              [5993, 8942],
              [5956, 8972],
              [5947, 9003],
              [5962, 9033],
              [5936, 9065],
              [5759, 9149],
              [5730, 9187],
              [5765, 9220],
              [5856, 9176],
              [5919, 9276],
              [5920, 9307],
              [5893, 9338],
              [5884, 9384],
              [5846, 9368],
              [5873, 9434],
              [5923, 9436],
              [5994, 9397],
              [6064, 9345],
              [6122, 9329],
              [6213, 9338],
              [6299, 9365],
              [6336, 9406],
              [6380, 9423],
              [6642, 9394],
              [6771, 9395],
              [6827, 9315],
              [7214, 9086],
              [7236, 9063],
              [7277, 8958],
              [7287, 8956],
              [7460, 8805]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.SH',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.28,
          'hc-middle-y': 0.39,
          'hc-key': 'ch-sh',
          'hc-a2': 'SH',
          labelrank: '9',
          hasc: 'CH.SH',
          'alt-name': 'Schaffhouse|Schaffusa|Sciaffusa',
          'woe-id': '2347098',
          subregion: null,
          fips: 'SZ16',
          'postal-code': 'SH',
          name: 'Schaffhausen',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '8.623200000000001',
          'woe-name': 'Schaffhausen',
          latitude: '47.7205',
          'woe-label': 'Canton of Schaffhausen, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [5388, 9354],
                [5329, 9371],
                [5215, 9352],
                [5112, 9294],
                [5070, 9292],
                [4962, 9367],
                [4914, 9382],
                [4929, 9420],
                [4914, 9475],
                [4940, 9527],
                [5025, 9582],
                [5043, 9651],
                [5086, 9723],
                [5257, 9757],
                [5292, 9775],
                [5271, 9830],
                [5308, 9851],
                [5366, 9847],
                [5409, 9828],
                [5423, 9715],
                [5446, 9698],
                [5475, 9717],
                [5487, 9793],
                [5509, 9815],
                [5539, 9805],
                [5597, 9702],
                [5670, 9697],
                [5685, 9662],
                [5640, 9580],
                [5668, 9528],
                [5678, 9479],
                [5802, 9480],
                [5783, 9502],
                [5804, 9570],
                [5867, 9567],
                [5944, 9522],
                [6004, 9465],
                [5961, 9455],
                [5961, 9431],
                [5994, 9397],
                [5923, 9436],
                [5873, 9434],
                [5846, 9368],
                [5752, 9311],
                [5656, 9315],
                [5619, 9332],
                [5595, 9374],
                [5599, 9483],
                [5498, 9486],
                [5462, 9435],
                [5388, 9354]
              ]
            ],
            [
              [
                [5289, 9142],
                [5310, 9116],
                [5346, 9135],
                [5316, 9043],
                [5281, 9018],
                [5236, 9068],
                [5238, 9093],
                [5289, 9142]
              ]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.UR',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.41,
          'hc-middle-y': 0.5,
          'hc-key': 'ch-ur',
          'hc-a2': 'UR',
          labelrank: '9',
          hasc: 'CH.UR',
          'alt-name': null,
          'woe-id': '2347103',
          subregion: null,
          fips: 'SZ21',
          'postal-code': 'UR',
          name: 'Uri',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '8.633010000000001',
          'woe-name': 'Uri',
          latitude: '46.809',
          'woe-label': 'Canton of Uri, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [6176, 6796],
              [6218, 6706],
              [6218, 6651],
              [6192, 6619],
              [6116, 6595],
              [6036, 6531],
              [6036, 6426],
              [6010, 6392],
              [5926, 6340],
              [5924, 6270],
              [5879, 6198],
              [5881, 6166],
              [5829, 6141],
              [5784, 6155],
              [5742, 6140],
              [5662, 6043],
              [5576, 6008],
              [5551, 5979],
              [5548, 5927],
              [5513, 5833],
              [5526, 5769],
              [5554, 5751],
              [5578, 5669],
              [5571, 5622],
              [5471, 5579],
              [5261, 5628],
              [5202, 5606],
              [5168, 5510],
              [5088, 5445],
              [4994, 5497],
              [4958, 5554],
              [4924, 5659],
              [4952, 5769],
              [4959, 5842],
              [4930, 5876],
              [4912, 5991],
              [4939, 6006],
              [5015, 5998],
              [5030, 6063],
              [4999, 6173],
              [5000, 6222],
              [5021, 6269],
              [5098, 6293],
              [5106, 6327],
              [5079, 6388],
              [5110, 6478],
              [5151, 6541],
              [5139, 6561],
              [5085, 6569],
              [5081, 6664],
              [5054, 6728],
              [5100, 6774],
              [5222, 6835],
              [5267, 6886],
              [5300, 6989],
              [5300, 7028],
              [5370, 7031],
              [5391, 7020],
              [5413, 6928],
              [5515, 6883],
              [5586, 6884],
              [5648, 6800],
              [5774, 6863],
              [5802, 6844],
              [5891, 6841],
              [5915, 6821],
              [5914, 6790],
              [5955, 6751],
              [5963, 6692],
              [6068, 6735],
              [6176, 6796]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.ZH',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.47,
          'hc-middle-y': 0.51,
          'hc-key': 'ch-zh',
          'hc-a2': 'ZH',
          labelrank: '7',
          hasc: 'CH.ZH',
          'alt-name': 'Turitg|Zurigo|Zürih|Zurique',
          'woe-id': '2347107',
          subregion: null,
          fips: 'SZ25',
          'postal-code': 'ZH',
          name: 'Zürich',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '8.6609',
          'woe-name': 'Zürich',
          latitude: '47.4297',
          'woe-label': 'Canton of Zurich, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [5846, 9368],
              [5884, 9384],
              [5893, 9338],
              [5920, 9307],
              [5919, 9276],
              [5856, 9176],
              [5765, 9220],
              [5730, 9187],
              [5759, 9149],
              [5936, 9065],
              [5962, 9033],
              [5947, 9003],
              [5956, 8972],
              [5993, 8942],
              [6063, 8914],
              [6085, 8889],
              [6072, 8775],
              [6048, 8749],
              [6056, 8701],
              [6079, 8686],
              [6091, 8615],
              [6133, 8582],
              [6088, 8485],
              [6182, 8385],
              [6248, 8269],
              [6269, 8168],
              [6185, 8066],
              [6187, 8037],
              [6154, 8001],
              [6015, 7936],
              [5887, 7947],
              [5843, 7913],
              [5810, 7833],
              [5708, 7812],
              [5615, 7754],
              [5578, 7716],
              [5592, 7642],
              [5539, 7635],
              [5452, 7680],
              [5410, 7740],
              [5326, 7824],
              [5233, 7839],
              [5122, 7811],
              [5070, 7816],
              [4960, 7858],
              [4940, 7924],
              [4888, 8037],
              [4883, 8065],
              [4959, 8099],
              [5026, 8193],
              [5033, 8226],
              [4963, 8205],
              [4928, 8260],
              [4934, 8330],
              [4858, 8386],
              [4862, 8404],
              [4926, 8468],
              [4936, 8497],
              [4898, 8552],
              [4881, 8606],
              [4830, 8717],
              [4818, 8766],
              [4832, 8867],
              [4871, 8930],
              [4923, 8981],
              [4977, 9068],
              [4981, 9089],
              [5047, 9100],
              [5078, 9175],
              [5150, 9222],
              [5220, 9229],
              [5256, 9195],
              [5289, 9142],
              [5238, 9093],
              [5236, 9068],
              [5281, 9018],
              [5316, 9043],
              [5346, 9135],
              [5357, 9153],
              [5357, 9288],
              [5388, 9300],
              [5407, 9265],
              [5420, 9347],
              [5388, 9354],
              [5462, 9435],
              [5498, 9486],
              [5599, 9483],
              [5595, 9374],
              [5619, 9332],
              [5656, 9315],
              [5752, 9311],
              [5846, 9368]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.ZG',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.41,
          'hc-middle-y': 0.54,
          'hc-key': 'ch-zg',
          'hc-a2': 'ZG',
          labelrank: '9',
          hasc: 'CH.ZG',
          'alt-name': 'Zoug|Zugo',
          'woe-id': '2347106',
          subregion: null,
          fips: 'SZ24',
          'postal-code': 'ZG',
          name: 'Zug',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '8.547470000000001',
          'woe-name': 'Zug',
          latitude: '47.1578',
          'woe-label': 'Canton of Zug, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [5592, 7642],
              [5636, 7611],
              [5593, 7567],
              [5575, 7515],
              [5508, 7436],
              [5482, 7416],
              [5364, 7378],
              [5315, 7372],
              [5273, 7401],
              [5151, 7392],
              [5110, 7485],
              [5069, 7494],
              [5020, 7464],
              [5006, 7502],
              [4962, 7518],
              [4933, 7566],
              [4917, 7688],
              [4906, 7834],
              [4909, 7865],
              [4940, 7924],
              [4960, 7858],
              [5070, 7816],
              [5122, 7811],
              [5233, 7839],
              [5326, 7824],
              [5410, 7740],
              [5452, 7680],
              [5539, 7635],
              [5592, 7642]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.VD',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.48,
          'hc-middle-y': 0.34,
          'hc-key': 'ch-vd',
          'hc-a2': 'VD',
          labelrank: '9',
          hasc: 'CH.VD',
          'alt-name': 'Vad|Waadt|Waadtland',
          'woe-id': '2347105',
          subregion: null,
          fips: 'SZ06',
          'postal-code': 'VD',
          name: 'Waadt',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '6.5118',
          'woe-name': 'Vaud',
          latitude: '46.6204',
          'woe-label': 'Canton of Vaud, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [1030, 5075],
                [1028, 5100],
                [1217, 5061],
                [1189, 5045],
                [1030, 5075]
              ]
            ],
            [
              [
                [1286, 6812],
                [1364, 6874],
                [1435, 6768],
                [1493, 6693],
                [1539, 6719],
                [1556, 6683],
                [1548, 6606],
                [1580, 6586],
                [1570, 6561],
                [1520, 6514],
                [1497, 6466],
                [1500, 6417],
                [1433, 6326],
                [1382, 6301],
                [1385, 6281],
                [1434, 6260],
                [1425, 6231],
                [1267, 6019],
                [1236, 5962],
                [1172, 5956],
                [1104, 5929],
                [1094, 5836],
                [1101, 5760],
                [1092, 5683],
                [1138, 5694],
                [1156, 5679],
                [1219, 5688],
                [1293, 5634],
                [1325, 5637],
                [1230, 5528],
                [1201, 5548],
                [1139, 5551],
                [1117, 5510],
                [1159, 5423],
                [1222, 5417],
                [1297, 5477],
                [1355, 5462],
                [1485, 5359],
                [1513, 5250],
                [1543, 5198],
                [1599, 5224],
                [1646, 5300],
                [1722, 5351],
                [1793, 5357],
                [1840, 5391],
                [1921, 5478],
                [2060, 5516],
                [2133, 5572],
                [2159, 5496],
                [2145, 5393],
                [2107, 5329],
                [2098, 5224],
                [2029, 5161],
                [2047, 5064],
                [2018, 4979],
                [2096, 4894],
                [2079, 4863],
                [2080, 4793],
                [2007, 4716],
                [2009, 4659],
                [1970, 4584],
                [1888, 4492],
                [1860, 4481],
                [1802, 4411],
                [1628, 4312],
                [1532, 4456],
                [1386, 4727],
                [1366, 4820],
                [1280, 4870],
                [1282, 4963],
                [1218, 5061],
                [1332, 5064],
                [1385, 5128],
                [1341, 5195],
                [1234, 5256],
                [1028, 5330],
                [638, 5483],
                [585, 5495],
                [376, 5485],
                [338, 5471],
                [192, 5359],
                [151, 5338],
                [-9, 5323],
                [-93, 5269],
                [-451, 4759],
                [-458, 4757],
                [-588, 4872],
                [-541, 4966],
                [-543, 5005],
                [-604, 5098],
                [-731, 5182],
                [-702, 5208],
                [-700, 5361],
                [-672, 5389],
                [-583, 5529],
                [-495, 5633],
                [-550, 5700],
                [-556, 5746],
                [-522, 5787],
                [-190, 6070],
                [-16, 6158],
                [74, 6246],
                [154, 6285],
                [208, 6336],
                [219, 6423],
                [190, 6461],
                [188, 6497],
                [229, 6609],
                [251, 6650],
                [418, 6658],
                [615, 6756],
                [688, 6778],
                [790, 6852],
                [933, 6933],
                [938, 6835],
                [976, 6783],
                [983, 6693],
                [1020, 6605],
                [1029, 6513],
                [1063, 6460],
                [1092, 6446],
                [1080, 6412],
                [1161, 6379],
                [1199, 6377],
                [1257, 6397],
                [1290, 6376],
                [1334, 6372],
                [1378, 6390],
                [1406, 6446],
                [1362, 6467],
                [1379, 6561],
                [1410, 6618],
                [1404, 6640],
                [1343, 6671],
                [1384, 6710],
                [1286, 6812]
              ],
              [
                [1294, 6247],
                [1292, 6299],
                [1236, 6349],
                [1161, 6265],
                [1150, 6242],
                [1106, 6223],
                [1089, 6189],
                [1125, 6191],
                [1171, 6221],
                [1239, 6188],
                [1276, 6213],
                [1294, 6247]
              ],
              [
                [1040, 6179],
                [1070, 6213],
                [1074, 6264],
                [1044, 6280],
                [986, 6224],
                [1023, 6165],
                [1040, 6179]
              ]
            ],
            [
              [
                [1458, 6947],
                [1640, 7090],
                [1737, 7047],
                [1751, 6930],
                [1807, 6801],
                [1835, 6783],
                [1808, 6745],
                [1782, 6757],
                [1753, 6681],
                [1719, 6633],
                [1677, 6612],
                [1672, 6646],
                [1601, 6735],
                [1458, 6947]
              ]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.3306',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.69,
          'hc-middle-y': 0.51,
          'hc-key': 'ch-3306',
          'hc-a2': 'BL',
          labelrank: '9',
          hasc: 'CH.BS',
          'alt-name': null,
          'woe-id': '2347085',
          subregion: null,
          fips: 'SZ05',
          'postal-code': null,
          name: 'Basel-Landschaft',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '7.72662',
          'woe-name': 'Basel-Landschaft',
          latitude: '47.5056',
          'woe-label': 'Canton of Basel-Country, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [2423, 8608],
                [2521, 8601],
                [2544, 8610],
                [2533, 8541],
                [2532, 8541],
                [2532, 8540],
                [2436, 8591],
                [2423, 8608]
              ]
            ],
            [
              [
                [2534, 8539],
                [2534, 8540],
                [2666, 8542],
                [2701, 8566],
                [2680, 8627],
                [2641, 8641],
                [2622, 8669],
                [2640, 8738],
                [2609, 8785],
                [2637, 8814],
                [2684, 8793],
                [2685, 8716],
                [2701, 8672],
                [2739, 8670],
                [2889, 8699],
                [2890, 8791],
                [2880, 8814],
                [2816, 8836],
                [2778, 8833],
                [2759, 8889],
                [2816, 8896],
                [2826, 8951],
                [2774, 8984],
                [2865, 9056],
                [2949, 8996],
                [2994, 8987],
                [3023, 8954],
                [3089, 8979],
                [3144, 8933],
                [3159, 8951],
                [3161, 9009],
                [3246, 8982],
                [3350, 9002],
                [3467, 8938],
                [3478, 8869],
                [3510, 8873],
                [3570, 8926],
                [3582, 8983],
                [3636, 8980],
                [3775, 8771],
                [3847, 8762],
                [3851, 8692],
                [3880, 8672],
                [3856, 8613],
                [3876, 8549],
                [3817, 8499],
                [3706, 8482],
                [3678, 8421],
                [3523, 8350],
                [3476, 8264],
                [3397, 8297],
                [3357, 8336],
                [3307, 8363],
                [3249, 8378],
                [3166, 8372],
                [3133, 8430],
                [3131, 8506],
                [3209, 8527],
                [3240, 8556],
                [3257, 8649],
                [3312, 8714],
                [3298, 8736],
                [3198, 8800],
                [3163, 8772],
                [3080, 8776],
                [3065, 8737],
                [3107, 8698],
                [3079, 8622],
                [3050, 8593],
                [2983, 8584],
                [2989, 8539],
                [2905, 8525],
                [2860, 8465],
                [2821, 8449],
                [2742, 8480],
                [2693, 8477],
                [2656, 8420],
                [2615, 8433],
                [2596, 8487],
                [2534, 8539]
              ]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.BE',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.48,
          'hc-middle-y': 0.55,
          'hc-key': 'ch-be',
          'hc-a2': 'BE',
          labelrank: '7',
          hasc: 'CH.BE',
          'alt-name': 'Berna|Berne',
          'woe-id': '2347087',
          subregion: null,
          fips: 'SZ05',
          'postal-code': 'BE',
          name: 'Bern',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '7.65026',
          'woe-name': 'Bern',
          latitude: '46.7988',
          'woe-label': 'Canton of Berne, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [3560, 8021],
                [3567, 7945],
                [3597, 7892],
                [3678, 7699],
                [3704, 7531],
                [3672, 7437],
                [3663, 7298],
                [3668, 7253],
                [3716, 7181],
                [3723, 7124],
                [3786, 7118],
                [3853, 7092],
                [3837, 7012],
                [3797, 6904],
                [3763, 6855],
                [3721, 6849],
                [3667, 6823],
                [3667, 6745],
                [3656, 6700],
                [3630, 6662],
                [3651, 6566],
                [3688, 6525],
                [3843, 6397],
                [3902, 6314],
                [3935, 6313],
                [4013, 6349],
                [4061, 6345],
                [4182, 6330],
                [4287, 6259],
                [4333, 6240],
                [4430, 6269],
                [4555, 6252],
                [4600, 6237],
                [4650, 6246],
                [4730, 6301],
                [4835, 6341],
                [4890, 6291],
                [4913, 6272],
                [4973, 6287],
                [5021, 6269],
                [5000, 6222],
                [4999, 6173],
                [5030, 6063],
                [5015, 5998],
                [4939, 6006],
                [4912, 5991],
                [4930, 5876],
                [4904, 5872],
                [4858, 5815],
                [4833, 5759],
                [4806, 5629],
                [4758, 5567],
                [4695, 5521],
                [4584, 5461],
                [4526, 5441],
                [4401, 5416],
                [4367, 5426],
                [4361, 5454],
                [4297, 5462],
                [4220, 5506],
                [4016, 5547],
                [3954, 5545],
                [3862, 5480],
                [3880, 5428],
                [3864, 5401],
                [3708, 5298],
                [3657, 5280],
                [3571, 5285],
                [3276, 5078],
                [3248, 5076],
                [3090, 5155],
                [3040, 5162],
                [2975, 5091],
                [2893, 5068],
                [2838, 5035],
                [2882, 4998],
                [2847, 4967],
                [2724, 4927],
                [2647, 4953],
                [2507, 4947],
                [2417, 4875],
                [2326, 4847],
                [2297, 4859],
                [2297, 4920],
                [2276, 4928],
                [2198, 4903],
                [2165, 4840],
                [2080, 4793],
                [2079, 4863],
                [2096, 4894],
                [2018, 4979],
                [2047, 5064],
                [2029, 5161],
                [2098, 5224],
                [2107, 5329],
                [2145, 5393],
                [2159, 5496],
                [2133, 5572],
                [2231, 5655],
                [2297, 5659],
                [2318, 5677],
                [2330, 5756],
                [2323, 5858],
                [2361, 5895],
                [2434, 5876],
                [2460, 5923],
                [2478, 6032],
                [2437, 6069],
                [2403, 6080],
                [2362, 6122],
                [2313, 6147],
                [2295, 6235],
                [2305, 6381],
                [2336, 6495],
                [2328, 6609],
                [2346, 6623],
                [2389, 6598],
                [2438, 6651],
                [2428, 6730],
                [2238, 6751],
                [2071, 6798],
                [2098, 6870],
                [2077, 6996],
                [2121, 7021],
                [2152, 7063],
                [2126, 7122],
                [2104, 7129],
                [1929, 7062],
                [1737, 7047],
                [1640, 7090],
                [1707, 7259],
                [1808, 7311],
                [1808, 7407],
                [1822, 7418],
                [1795, 7455],
                [1695, 7505],
                [1695, 7553],
                [1314, 7446],
                [1307, 7468],
                [1331, 7515],
                [1345, 7581],
                [1324, 7645],
                [1298, 7682],
                [1250, 7709],
                [1315, 7703],
                [1354, 7669],
                [1399, 7688],
                [1514, 7766],
                [1592, 7767],
                [1705, 7851],
                [1788, 7967],
                [1862, 7958],
                [1979, 7977],
                [1991, 7989],
                [1989, 8058],
                [2023, 8085],
                [2030, 8148],
                [2229, 8103],
                [2310, 8112],
                [2371, 8132],
                [2458, 8188],
                [2498, 8231],
                [2533, 8191],
                [2791, 8165],
                [2933, 8202],
                [2914, 8149],
                [2877, 8118],
                [2799, 8095],
                [2713, 8022],
                [2659, 8001],
                [2609, 7960],
                [2614, 7935],
                [2435, 7859],
                [2429, 7843],
                [2455, 7781],
                [2510, 7746],
                [2550, 7661],
                [2594, 7675],
                [2647, 7732],
                [2734, 7764],
                [2742, 7703],
                [2768, 7672],
                [2717, 7633],
                [2683, 7644],
                [2637, 7585],
                [2639, 7535],
                [2567, 7513],
                [2494, 7523],
                [2492, 7496],
                [2542, 7424],
                [2635, 7443],
                [2656, 7365],
                [2724, 7399],
                [2712, 7467],
                [2720, 7491],
                [2784, 7520],
                [2818, 7550],
                [2882, 7639],
                [2942, 7674],
                [3005, 7629],
                [3129, 7626],
                [3209, 7713],
                [3194, 7762],
                [3124, 7880],
                [3081, 7900],
                [3038, 7954],
                [3027, 8019],
                [2994, 8060],
                [3152, 8077],
                [3238, 8114],
                [3317, 8017],
                [3344, 7999],
                [3409, 7994],
                [3560, 8021]
              ],
              [
                [2142, 6886],
                [2150, 6909],
                [2115, 6900],
                [2122, 6882],
                [2142, 6886]
              ]
            ],
            [
              [
                [2930, 8292],
                [2960, 8270],
                [2959, 8212],
                [2939, 8211],
                [2895, 8217],
                [2891, 8257],
                [2930, 8292]
              ]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.BS',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.71,
          'hc-middle-y': 0.17,
          'hc-key': 'ch-bs',
          'hc-a2': 'BS',
          labelrank: '9',
          hasc: 'CH.BS',
          'alt-name': 'Bâle-Ville|Basel-City|Basel-Town|Basilea-Citad|Basilea Ciudad|Basilea città|Basiléia cidade',
          'woe-id': '2347086',
          subregion: null,
          fips: 'SZ03',
          'postal-code': 'BS',
          name: 'Basel-Stadt',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '7.5898',
          'woe-name': 'Basel-Stadt',
          latitude: '47.5605',
          'woe-label': 'Canton of Basel-City, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [2865, 9056],
              [2935, 9096],
              [3020, 9126],
              [3140, 9160],
              [3193, 9165],
              [3161, 9078],
              [3136, 9055],
              [3074, 9056],
              [3161, 9009],
              [3159, 8951],
              [3144, 8933],
              [3089, 8979],
              [3023, 8954],
              [2994, 8987],
              [2949, 8996],
              [2865, 9056]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.SO',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.26,
          'hc-middle-y': 0.66,
          'hc-key': 'ch-so',
          'hc-a2': 'SO',
          labelrank: '9',
          hasc: 'CH.',
          'alt-name': 'Solothurn',
          'woe-id': '2347100',
          subregion: null,
          fips: 'SZ18',
          'postal-code': 'SO',
          name: 'Solothurn',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '7.41999',
          'woe-name': 'Solothurn',
          latitude: '47.4325',
          'woe-label': 'Canton of Solothurn, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [2544, 8610],
                [2587, 8626],
                [2622, 8669],
                [2641, 8641],
                [2680, 8627],
                [2701, 8566],
                [2666, 8542],
                [2534, 8540],
                [2534, 8541],
                [2533, 8541],
                [2544, 8610]
              ]
            ],
            [
              [
                [3880, 8672],
                [3917, 8665],
                [3937, 8640],
                [3941, 8579],
                [3967, 8521],
                [3998, 8485],
                [4050, 8463],
                [4052, 8397],
                [3974, 8243],
                [3937, 8222],
                [3787, 8246],
                [3750, 8259],
                [3643, 8165],
                [3560, 8021],
                [3409, 7994],
                [3344, 7999],
                [3317, 8017],
                [3238, 8114],
                [3152, 8077],
                [2994, 8060],
                [3027, 8019],
                [3038, 7954],
                [3081, 7900],
                [3124, 7880],
                [3194, 7762],
                [3209, 7713],
                [3129, 7626],
                [3005, 7629],
                [2942, 7674],
                [2882, 7639],
                [2818, 7550],
                [2784, 7520],
                [2720, 7491],
                [2712, 7467],
                [2724, 7399],
                [2656, 7365],
                [2635, 7443],
                [2542, 7424],
                [2492, 7496],
                [2494, 7523],
                [2567, 7513],
                [2639, 7535],
                [2637, 7585],
                [2683, 7644],
                [2717, 7633],
                [2768, 7672],
                [2742, 7703],
                [2734, 7764],
                [2647, 7732],
                [2594, 7675],
                [2550, 7661],
                [2510, 7746],
                [2455, 7781],
                [2429, 7843],
                [2435, 7859],
                [2614, 7935],
                [2609, 7960],
                [2659, 8001],
                [2713, 8022],
                [2799, 8095],
                [2877, 8118],
                [2914, 8149],
                [2933, 8202],
                [2939, 8211],
                [2959, 8212],
                [2960, 8270],
                [2930, 8292],
                [2871, 8362],
                [2832, 8384],
                [2770, 8389],
                [2656, 8420],
                [2693, 8477],
                [2742, 8480],
                [2821, 8449],
                [2860, 8465],
                [2905, 8525],
                [2989, 8539],
                [2983, 8584],
                [3050, 8593],
                [3079, 8622],
                [3107, 8698],
                [3065, 8737],
                [3080, 8776],
                [3163, 8772],
                [3198, 8800],
                [3298, 8736],
                [3312, 8714],
                [3257, 8649],
                [3240, 8556],
                [3209, 8527],
                [3131, 8506],
                [3133, 8430],
                [3166, 8372],
                [3249, 8378],
                [3307, 8363],
                [3357, 8336],
                [3397, 8297],
                [3476, 8264],
                [3523, 8350],
                [3678, 8421],
                [3706, 8482],
                [3817, 8499],
                [3876, 8549],
                [3856, 8613],
                [3880, 8672]
              ]
            ],
            [
              [
                [2684, 8793],
                [2734, 8775],
                [2778, 8833],
                [2816, 8836],
                [2880, 8814],
                [2890, 8791],
                [2889, 8699],
                [2739, 8670],
                [2701, 8672],
                [2685, 8716],
                [2684, 8793]
              ]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.OW',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.32,
          'hc-middle-y': 0.54,
          'hc-key': 'ch-ow',
          'hc-a2': 'OW',
          labelrank: '9',
          hasc: 'CH.OW',
          'alt-name': 'Obvaldo|Obwald|Unterwalden-le-Haut|Obwaldo|Sursilvania',
          'woe-id': '2347096',
          subregion: null,
          fips: 'SZ14',
          'postal-code': 'OW',
          name: 'Obwalden',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '8.20594',
          'woe-name': 'Obwalden',
          latitude: '46.8686',
          'woe-label': 'Canton of Obwalden, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [5085, 6569],
                [5139, 6561],
                [5151, 6541],
                [5110, 6478],
                [5079, 6388],
                [5106, 6327],
                [5098, 6293],
                [5021, 6269],
                [4973, 6287],
                [4913, 6272],
                [4890, 6291],
                [4959, 6312],
                [4953, 6338],
                [4916, 6353],
                [4847, 6449],
                [4848, 6482],
                [4818, 6611],
                [4846, 6632],
                [4856, 6580],
                [4915, 6611],
                [4936, 6607],
                [4970, 6566],
                [5085, 6569]
              ]
            ],
            [
              [
                [4835, 6341],
                [4730, 6301],
                [4650, 6246],
                [4600, 6237],
                [4555, 6252],
                [4430, 6269],
                [4333, 6240],
                [4287, 6259],
                [4182, 6330],
                [4061, 6345],
                [4101, 6406],
                [4070, 6522],
                [4118, 6634],
                [4144, 6726],
                [4184, 6763],
                [4228, 6749],
                [4286, 6821],
                [4334, 6865],
                [4327, 6931],
                [4373, 6965],
                [4505, 6977],
                [4592, 7003],
                [4682, 6974],
                [4696, 6960],
                [4657, 6854],
                [4683, 6825],
                [4739, 6798],
                [4756, 6773],
                [4755, 6680],
                [4739, 6625],
                [4732, 6521],
                [4737, 6439],
                [4786, 6371],
                [4835, 6341]
              ]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.AI',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.27,
          'hc-middle-y': 0.68,
          'hc-key': 'ch-ai',
          'hc-a2': 'AI',
          labelrank: '9',
          hasc: 'CH.AI',
          'alt-name':
            'Appenzell Inner-Rhoden|Appenzell Inner Rhodes|Appenzell dador|Appenzell Rhodes Intérieures|Appenzello Interno',
          'woe-id': '2347092',
          subregion: null,
          fips: 'SZ10',
          'postal-code': 'AI',
          name: 'Appenzell Innerrhoden',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '9.395479999999999',
          'woe-name': 'Appenzell Innerrhoden',
          latitude: '47.3092',
          'woe-label': 'Canton of Appenzell Inner-Rhodes, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [7125, 7947],
                [7100, 8025],
                [7070, 8070],
                [7057, 8121],
                [7071, 8223],
                [7125, 8275],
                [7150, 8332],
                [7152, 8401],
                [7166, 8415],
                [7418, 8299],
                [7494, 8297],
                [7455, 8099],
                [7409, 8012],
                [7376, 7975],
                [7296, 7926],
                [7230, 7901],
                [7194, 7905],
                [7125, 7947]
              ]
            ],
            [
              [
                [7616, 8450],
                [7583, 8467],
                [7489, 8436],
                [7496, 8476],
                [7548, 8503],
                [7546, 8549],
                [7585, 8576],
                [7621, 8539],
                [7616, 8450]
              ]
            ],
            [
              [
                [7775, 8633],
                [7721, 8579],
                [7712, 8545],
                [7637, 8581],
                [7633, 8603],
                [7714, 8608],
                [7775, 8633]
              ]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.GE',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.41,
          'hc-middle-y': 0.68,
          'hc-key': 'ch-ge',
          'hc-a2': 'GE',
          labelrank: '9',
          hasc: 'CH.GE',
          'alt-name': 'Cenevre|Genebra|Geneve|Geneva|Genevra|Genf|Ginebra|Ginevra',
          'woe-id': '2347089',
          subregion: null,
          fips: 'SZ07',
          'postal-code': 'GE',
          name: 'Genf',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '6.11764',
          'woe-name': 'Genève',
          latitude: '46.237',
          'woe-label': 'Canton of Geneva, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [-588, 4872],
              [-458, 4757],
              [-452, 4757],
              [-496, 4650],
              [-517, 4520],
              [-535, 4504],
              [-568, 4430],
              [-444, 4544],
              [-338, 4734],
              [-309, 4640],
              [-275, 4611],
              [-217, 4620],
              [-207, 4540],
              [-272, 4476],
              [-430, 4380],
              [-558, 4240],
              [-638, 4203],
              [-719, 4242],
              [-829, 4242],
              [-939, 4220],
              [-999, 4188],
              [-935, 4326],
              [-999, 4429],
              [-988, 4471],
              [-928, 4506],
              [-781, 4571],
              [-722, 4564],
              [-668, 4578],
              [-657, 4601],
              [-655, 4671],
              [-625, 4795],
              [-588, 4872]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        id: 'CH.JU',
        properties: {
          'hc-group': 'admin1',
          'hc-middle-x': 0.42,
          'hc-middle-y': 0.38,
          'hc-key': 'ch-ju',
          'hc-a2': 'JU',
          labelrank: '9',
          hasc: 'CH.JU',
          'alt-name': 'Giura',
          'woe-id': '2347108',
          subregion: null,
          fips: 'SZ26',
          'postal-code': 'JU',
          name: 'Jura',
          country: 'Switzerland',
          'type-en': 'Canton',
          region: null,
          longitude: '7.19817',
          'woe-name': 'Jura',
          latitude: '47.3636',
          'woe-label': 'Canton of Jura, CH, Switzerland',
          type: 'Canton|Kanton|Chantun'
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [1250, 7709],
              [1222, 7721],
              [1275, 7798],
              [1346, 7867],
              [1509, 7981],
              [1502, 8067],
              [1519, 8138],
              [1565, 8183],
              [1599, 8190],
              [1635, 8235],
              [1706, 8269],
              [1726, 8306],
              [1702, 8342],
              [1633, 8405],
              [1589, 8385],
              [1308, 8365],
              [1321, 8409],
              [1387, 8507],
              [1449, 8541],
              [1455, 8606],
              [1517, 8619],
              [1591, 8669],
              [1610, 8697],
              [1576, 8788],
              [1572, 8827],
              [1658, 8860],
              [1701, 8837],
              [1761, 8826],
              [1879, 8844],
              [1996, 8807],
              [2060, 8812],
              [2015, 8714],
              [2027, 8657],
              [2077, 8625],
              [2146, 8602],
              [2171, 8568],
              [2205, 8563],
              [2295, 8600],
              [2358, 8612],
              [2423, 8608],
              [2436, 8591],
              [2532, 8540],
              [2532, 8539],
              [2534, 8539],
              [2534, 8539],
              [2596, 8487],
              [2615, 8433],
              [2656, 8420],
              [2770, 8389],
              [2832, 8384],
              [2871, 8362],
              [2930, 8292],
              [2891, 8257],
              [2895, 8217],
              [2939, 8211],
              [2933, 8202],
              [2791, 8165],
              [2533, 8191],
              [2498, 8231],
              [2458, 8188],
              [2371, 8132],
              [2310, 8112],
              [2229, 8103],
              [2030, 8148],
              [2023, 8085],
              [1989, 8058],
              [1991, 7989],
              [1979, 7977],
              [1862, 7958],
              [1788, 7967],
              [1705, 7851],
              [1592, 7767],
              [1514, 7766],
              [1399, 7688],
              [1354, 7669],
              [1315, 7703],
              [1250, 7709]
            ]
          ]
        }
      }
    ]
  };
}
